// Re-admission forms do not carry subject data any more. Subjects are allotted
// by the college and maintained through the Subject Update panel in the student
// portal, so the admission form leaves those columns empty.
//
// The print/preview views read `major_1.label`, `mil.label` etc. directly, which
// would throw on an empty column. This fills the empty ones with `{}` (and an
// empty list for `optional_subjects`) so they simply render blank.
//
// Forms that do carry subjects are returned unchanged.

const SUBJECT_FIELDS = [
  "major_1",
  "major_2",
  "major_3",
  "compulsory_1",
  "compulsory_2",
  "compulsory_3",
  "mil",
  "generic_1",
  "generic_2",
  "generic_3",
];

export default function safeSubjects(data) {
  let d = { ...data };

  SUBJECT_FIELDS.forEach((field) => {
    if (d[field] === null || d[field] === undefined) {
      d[field] = {};
    }
  });

  if (!Array.isArray(d.optional_subjects)) {
    d.optional_subjects = [];
  }

  return d;
}
